module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('p', [_vm._v("\n        Search Users By Email:\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "autofocus": ""
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "big-btn blue",
    on: {
      "click": function($event) {
        _vm.searchUsers()
      }
    }
  }, [_vm._v("\n          Search Users\n        ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.users.length) ? _c('table', [_c('h4', [_vm._v("Users:")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('tr', {
      key: user.id
    }, [_c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.premium === "1" ? "Yes" : "No"))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn orange",
      on: {
        "click": function($event) {
          _vm.editUser(user)
        }
      }
    }, [_vm._v("\n              Edit\n            ")])])])
  })], 2) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Premium")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-532c95be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/Users.vue
// module id = 500
// module chunks = 1